import { StandardizedCategoryDocumentIDDefault } from './standardizedCategories/standardizedCategory';

export const SupportedMatchInfoHashCategoryDefault = StandardizedCategoryDocumentIDDefault;
export const SupportedMatchInfoHashCategories = [SupportedMatchInfoHashCategoryDefault, 'apparel', 'bras', 'beauty', 'skincare'] as const;
export type SupportedMatchInfoHashCategory = (typeof SupportedMatchInfoHashCategories)[number];
export type SupportedMatchInfoHashCategoryMapping = Record<SupportedMatchInfoHashCategory, string | null>;
export type SupportedMatchInfoHasHashCategoryMapping = Record<SupportedMatchInfoHashCategory, boolean>;

export const SupportedMatchInfoHashCategoryMappingEmpty: SupportedMatchInfoHashCategoryMapping = {
  default: null,
  apparel: null,
  bras: null,
  beauty: null,
  skincare: null,
};

export const createHasMatchInfoMapping = (matchInfoHashes: SupportedMatchInfoHashCategoryMapping): SupportedMatchInfoHasHashCategoryMapping => {
  const hasMatchInfo: SupportedMatchInfoHasHashCategoryMapping = {} as SupportedMatchInfoHasHashCategoryMapping;
  Object.keys(matchInfoHashes).forEach((id) => {
    const cleanID = id as SupportedMatchInfoHashCategory;
    hasMatchInfo[cleanID] = !!matchInfoHashes[cleanID];
  });
  return hasMatchInfo;
};

export const hasAnyMatchInfo = (matchInfoHashes?: SupportedMatchInfoHashCategoryMapping): boolean => {
  if (!matchInfoHashes) {
    return false;
  }
  return !!Object.values(matchInfoHashes).find((hash) => !!hash);
};
